function collectStructuredTextParts(content: unknown): string[] {
  if (typeof content === 'string') {
    return content.trim() ? [content.trim()] : [];
  }

  if (Array.isArray(content)) {
    return content.flatMap((item) => collectStructuredTextParts(item));
  }

  if (!content || typeof content !== 'object') {
    return [];
  }

  const record = content as Record<string, unknown>;

  if (typeof record.text === 'string') {
    return record.text.trim() ? [record.text.trim()] : [];
  }

  if (record.text && typeof record.text === 'object') {
    return collectStructuredTextParts(record.text);
  }

  if (typeof record.value === 'string') {
    return record.value.trim() ? [record.value.trim()] : [];
  }

  if (record.content !== undefined) {
    return collectStructuredTextParts(record.content);
  }

  return [];
}

function isStructuredAssistantPayload(content: unknown): boolean {
  if (Array.isArray(content)) {
    return content.some((item) => isStructuredAssistantPayload(item));
  }

  if (!content || typeof content !== 'object') {
    return false;
  }

  const record = content as Record<string, unknown>;
  if (record.type === 'text') {
    return true;
  }

  return record.content !== undefined
    ? isStructuredAssistantPayload(record.content)
    : false;
}

export function normalizeAssistantContent(content: string): string {
  const trimmedContent = content.trim();
  if (!trimmedContent.startsWith('[') && !trimmedContent.startsWith('{')) {
    return content;
  }

  try {
    const parsed = JSON.parse(trimmedContent);
    if (!isStructuredAssistantPayload(parsed)) {
      return content;
    }

    const extracted = collectStructuredTextParts(parsed).join('\n').trim();
    return extracted || content;
  } catch {
    return content;
  }
}
